import { Modal } from '@arco-design/web-vue'
import OffLine from '~/components/identity/OffLine.vue'

export function useOffLineModal() {
  const isModalOpen = useState('isModalOpen', () => false)
  const { $i18n } = useNuxtApp()
  const { logout, toggleDialog } = useLogin()
  function closeModal(val = false) {
    isModalOpen.value = false
    logout()
    if (val) {
      toggleDialog(true, true)
      return
    }
    location.reload() // 同账号登录状态要刷新
  }
  return {
    open: (code: number, message?: string) => {
      if (isModalOpen.value) {
        return
      }
      const offlineModal = Modal.open({
        title: code === 40101 ? $i18n.t('下线通知') : undefined,
        skip: true,
        footer: false,
        maskClosable: false,
        hideCancel: true,
        hideTitle: code !== 40101,
        width: code === 40101 ? 400 : 344,
        content: () => h(
          OffLine,
          {
            code,
            message,
            onCancel: () => {
              closeModal()
              offlineModal.close()
            },
            onOk: () => {
              closeModal(true)
              offlineModal.close()
            },
          },
        ),
        onCancel: () => {
          closeModal()
          offlineModal.close()
        },
      })
      isModalOpen.value = true
    },
  }
}
